import {
  createMuiTheme,
  CssBaseline,
  Drawer,
  makeStyles,
  ThemeProvider,
} from "@material-ui/core";
import React from "react";
import Header from "../../../components/Admin/Header";
import red from "@material-ui/core/colors/red";

import MyDrawer from "../../../components/Admin/Drawer";
import { VideoProvider } from "../../Media/Videos/VideoContext";
import Videos from "./Videos";
import { useStyles, theme } from "../theme.js";

const VideoAdminPage = (props) => {
  const classes = useStyles();

  return (
    <VideoProvider>
      <ThemeProvider theme={theme}>
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
          anchor="left"
        >
          <MyDrawer></MyDrawer>
        </Drawer>
        <div className={classes.adminMain}>
          <Header></Header>
          <Videos></Videos>
        </div>
        <CssBaseline></CssBaseline>
      </ThemeProvider>
    </VideoProvider>
  );
};

export default VideoAdminPage;
